/**
 * Configurator: Plissee nach Mass (Pleated Blinds)
 *
 * Price tables are loaded from assets/plissee-prices.json (CDN-hosted theme asset).
 * To update prices: edit plissee-prices.json in Shopify Admin → Themes → Edit code → Assets.
 *
 * Sections:
 *   1. Helpers        — formatPrice(), snapToBracket()
 *   2. Config         — read data attributes set by configurator-plissee.liquid
 *   3. Init           — fetch plissee-prices.json, then wire up events
 *   4. Lookup         — lookupPrice(widthCm, heightCm)
 *   5. Validate       — validateAll(), enforce min/max per dimension
 *   6. Befestigungsart — tile selection, required before cart
 *   7. Cart           — intercept add-to-cart, call duplicate_plissee.cfm, then /cart/add.js
 */

$(document).ready(function () {

  // ─────────────────────────────────────────────
  // 1. Helpers
  // ─────────────────────────────────────────────

  function formatPrice(amount) {
    // Swiss format: "CHF 1'234.50"
    return 'CHF ' + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  }

  function roundOneDecimal(num) {
    return Math.round(num * 10) / 10;
  }

  /**
   * snapToBracket — index of first bracket >= valueCm.
   * Returns -1 if valueCm exceeds the highest bracket (caught by validation).
   */
  function snapToBracket(valueCm, brackets) {
    for (var i = 0; i < brackets.length; i++) {
      if (valueCm <= brackets[i]) return i;
    }
    return -1;
  }

  // ─────────────────────────────────────────────
  // 2. Config
  // ─────────────────────────────────────────────

  var $container = $('[data-plissee-configurator]');

  // Bail out if no plissee configurator on this page
  if ($container.length === 0) return;

  var model         = $container.data('model');
  var priceTableUrl = $container.attr('data-price-table-url');
  var minWidth      = parseInt($container.data('min-width'),  10);
  var minHeight     = parseInt($container.data('min-height'), 10);

  var $widthInput        = $('#plissee-breite');
  var $heightInput       = $('#plissee-hoehe');
  var $aufhaengeort      = $('#plissee-aufhaengeort');
  var $widthError        = $('[data-plissee-width-error]');
  var $heightError       = $('[data-plissee-height-error]');
  var $befestigungError  = $('[data-plissee-befestigung-error]');
  var $befestigungTiles  = $('.plissee-befestigung-tile');
  var $addToCart         = $('[data-add-to-cart-trigger]');

  var selectedBefestigung = '';

  // Disable add-to-cart immediately — wait for JSON + valid inputs
  $addToCart.prop('disabled', true);

  // ─────────────────────────────────────────────
  // 3. Init — fetch price table, then wire events
  // ─────────────────────────────────────────────

  $.getJSON(priceTableUrl)
    .done(function (allTables) {
      var priceTable = allTables[model];

      if (!priceTable) {
        console.error('z__jsPlissee: unknown model "' + model + '" in plissee-prices.json');
        return;
      }

      var maxWidth  = priceTable.widths[priceTable.widths.length - 1];
      var maxHeight = priceTable.heights[priceTable.heights.length - 1];

      // Update placeholder text to reflect model's actual max
      $widthInput.attr('placeholder',  'Min. ' + minWidth  + ' – Max. ' + maxWidth  + ' cm');
      $heightInput.attr('placeholder', 'Min. ' + minHeight + ' – Max. ' + maxHeight + ' cm');

      // ── 4. Lookup ──────────────────────────────────────────────────────────

      function lookupPrice(widthCm, heightCm) {
        var wIdx = snapToBracket(widthCm,  priceTable.widths);
        var hIdx = snapToBracket(heightCm, priceTable.heights);
        if (wIdx === -1 || hIdx === -1) return null;
        return priceTable.prices[hIdx][wIdx];
      }

      // ── 5. Validate ────────────────────────────────────────────────────────

      function showWidthError(msg)  { $widthError.text(msg).show(); }
      function clearWidthError()    { $widthError.text('').hide(); }
      function showHeightError(msg) { $heightError.text(msg).show(); }
      function clearHeightError()   { $heightError.text('').hide(); }

      function validateAll() {
        var rawW = parseFloat($widthInput.val());
        var rawH = parseFloat($heightInput.val());
        var widthCm  = isNaN(rawW) ? rawW : roundOneDecimal(rawW);
        var heightCm = isNaN(rawH) ? rawH : roundOneDecimal(rawH);
        var widthOk  = false;
        var heightOk = false;

        // Width
        if (isNaN(widthCm) || $widthInput.val() === '') {
          clearWidthError();
        } else if (widthCm < minWidth) {
          showWidthError('Mindestbreite: ' + minWidth + ' cm');
        } else if (widthCm > maxWidth) {
          showWidthError('Maximalbreite: ' + maxWidth + ' cm');
        } else {
          clearWidthError();
          widthOk = true;
        }

        // Height
        if (isNaN(heightCm) || $heightInput.val() === '') {
          clearHeightError();
        } else if (heightCm < minHeight) {
          showHeightError('Mindesthöhe: ' + minHeight + ' cm');
        } else if (heightCm > maxHeight) {
          showHeightError('Maximalhöhe: ' + maxHeight + ' cm');
        } else {
          clearHeightError();
          heightOk = true;
        }

        // Update price display
        if (widthOk && heightOk) {
          var price = lookupPrice(widthCm, heightCm);
          if (price !== null) {
            $('.purchase-details .price .money')
              .text(formatPrice(price))
              .attr('data-price', price);
          }
        } else {
          $('.purchase-details .price .money')
            .text('–')
            .removeAttr('data-price');
        }

        $addToCart.prop('disabled', !(widthOk && heightOk));
      }

      // ── 6. Befestigungsart tile selection ──────────────────────────────────

      $befestigungTiles.on('click', function () {
        $befestigungTiles.removeClass('active');
        $(this).addClass('active');
        selectedBefestigung = $(this).data('value');
        $befestigungError.text('').hide();
      });

      // ── Wire input events ──────────────────────────────────────────────────

      $widthInput.on('input change',  validateAll);
      $heightInput.on('input change', validateAll);

      function snapInputOnBlur() {
        var raw = parseFloat($(this).val());
        if (!isNaN(raw)) {
          $(this).val(roundOneDecimal(raw));
        }
      }
      $widthInput.on('blur',  snapInputOnBlur);
      $heightInput.on('blur', snapInputOnBlur);

      // ── 7. Cart ────────────────────────────────────────────────────────────

      $addToCart.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if ($addToCart.hasClass('disabled')) return;

        var rawW2 = parseFloat($widthInput.val());
        var rawH2 = parseFloat($heightInput.val());
        var widthCm  = isNaN(rawW2) ? rawW2 : roundOneDecimal(rawW2);
        var heightCm = isNaN(rawH2) ? rawH2 : roundOneDecimal(rawH2);

        var wOk = !isNaN(widthCm)  && widthCm  >= minWidth  && widthCm  <= maxWidth;
        var hOk = !isNaN(heightCm) && heightCm >= minHeight && heightCm <= maxHeight;
        if (!wOk || !hOk) {
          validateAll();
          return;
        }

        // Befestigungsart required
        if (!selectedBefestigung) {
          $befestigungError.text('Bitte Befestigungsart auswählen.').show();
          return;
        }

        var price = lookupPrice(widthCm, heightCm);
        if (price === null) return;

        var aufhaengeort = $.trim($aufhaengeort.val());

        var productData = {
          pid:                  $('[data-product-id]').data('product-id'),
          productType:          'plissee',
          price:                price,
          title:                $('.vs-product-title').text().trim(),
          Breite:               widthCm,
          Hoehe:                heightCm,
          Befestigungsart:      selectedBefestigung,
          original_product_url: window.location.href
        };

        if (aufhaengeort !== '') {
          productData.Aufhaengeort = aufhaengeort;
        }

        // Disable buttons while loading
        $addToCart.addClass('disabled button_loading');
        $('.fabric-sample > button').addClass('disabled');

        var shopDomain = window.PXUTheme.theme_settings.domain;

        $.ajax({
          type:        'POST',
          url:         'https://apps.vorhangschweiz.ch/functions/duplicate_plissee.cfm',
          data:        JSON.stringify(productData),
          contentType: 'application/json',
          dataType:    'json',
          headers:     { 'x-shopify-shop': shopDomain },

          success: function (data) {
            if (data.success !== true) {
              console.error('duplicate_plissee.cfm error', data);
              $addToCart.removeClass('disabled button_loading');
              $('.fabric-sample > button').removeClass('disabled');
              return;
            }

            var cartProperties = {
              'Breite':                widthCm  + ' cm',
              'Höhe':                  heightCm + ' cm',
              'Befestigungsart':       selectedBefestigung,
              'Aluminiumfarbe':        'Weiss',
              'Griffe':                'Standard Kunststoff',
              '_original_product_url': productData.original_product_url
            };

            if (aufhaengeort !== '') {
              cartProperties['Aufhängeort'] = aufhaengeort;
            }

            var lieferzeitEl = $('[data-lieferzeit]');
            if (lieferzeitEl.length) {
              var lieferzeitVal = lieferzeitEl.text().trim();
              if (lieferzeitVal) {
                cartProperties['_Lieferzeit'] = lieferzeitVal;
              }
            }

            $.ajax({
              type:     'POST',
              url:      '/cart/add.js',
              dataType: 'json',
              data: {
                items: [{
                  id:         data.vid,
                  quantity:   parseInt($('.quantityPrice input.quantity-input.quantity-element').val()) || 1,
                  properties: cartProperties
                }]
              },

              success: function () {
                $addToCart.removeClass('button_loading');
                $addToCart.find('svg.checkmark').addClass('checkmark-active');
                window.PXUTheme.jsAjaxCart.updateView();

                setTimeout(function () {
                  $addToCart.find('i, span').hide();
                }, 300);

                setTimeout(function () {
                  $('.header-cart.action-area__link').addClass('show-mini-cart');
                  $addToCart.removeClass('disabled');
                  $('.fabric-sample > button').removeClass('disabled');
                  $addToCart.find('i, span').removeClass('zoomOut').show();
                  $addToCart.find('svg.checkmark').removeClass('checkmark-active');
                }, 2000);
              },

              error: function (xhr) {
                console.error('/cart/add.js error', xhr);
                $addToCart.removeClass('disabled button_loading');
                $('.fabric-sample > button').removeClass('disabled');
              }
            });
          },

          error: function (xhr) {
            console.error('duplicate_plissee.cfm request failed', xhr);
            $addToCart.removeClass('disabled button_loading');
            $('.fabric-sample > button').removeClass('disabled');
          }
        });
      });

    })
    .fail(function (xhr) {
      console.error('z__jsPlissee: failed to load plissee-prices.json', xhr.status, xhr.statusText);
    });

});
